import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import SaleCountdown from 'Component/SaleCountdown';
/** @namespace Bodypwa/Component/SaleCountdownWidget/Container/mapDispatchToProps */
const mapDispatchToProps = () => ({
});

/** @namespace Bodypwa/Component/SaleCountdownWidget/Container/mapStateToProps */
const mapStateToProps = () => ({});

/** @namespace Bodypwa/Component/SaleCountdownWidget/Container */
export class SaleCountdownWidgetContainer extends PureComponent {
     static propTypes = {
         widgetProps: PropTypes.shape({
             startDate: PropTypes.string.isRequired,
             endDate: PropTypes.string.isRequired,
             gmt: PropTypes.string.isRequired,
             fontSize: PropTypes.string,
             fontColor: PropTypes.string,
             fontWeight: PropTypes.string
         }).isRequired
     };

     containerProps() {
         const {
             widgetProps: {
                 'data-start-date': startDate,
                 'data-end-date': endDate,
                 'data-gmt': gmt,
                 'data-font-size': fontSize,
                 'data-font-color': fontColor,
                 'data-font-weight': fontWeight
             } = {}
         } = this.props;

         return {
             widgetCampaignCountdownStartDate: startDate,
             widgetCampaignCountdownEndDate: endDate,
             widgetCampaignCountdownGtmAdjustment: gmt,
             campaignLable: 'widget',
             fontSize,
             fontColor,
             fontWeight,
             isWidget: true
         };
     }

     renderContent() {
         return (
            <SaleCountdown
                { ...this.containerProps() }
            />
         );
     }

     render() {
         return this.renderContent();
     }
}

export default connect(mapStateToProps, mapDispatchToProps)(SaleCountdownWidgetContainer);
